import { useState, useMemo } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList, CommandInput } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Check, ChevronsUpDown, X } from "lucide-react";

export default function MemberCombobox({ members, value, onChange, placeholder = "Seleziona un socio…", testid }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const selected = members.find((m) => m.id === value);

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    const list = q
      ? members.filter((m) => `${m.nome} ${m.cognome} ${m.club || ""}`.toLowerCase().includes(q))
      : members;
    return list.slice(0, 50);
  }, [members, query]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" aria-expanded={open} data-testid={testid}
          className="w-full justify-between font-normal border-navy/20">
          <span className={selected ? "text-navy-deep truncate" : "text-muted-foreground"}>
            {selected ? `${selected.nome} ${selected.cognome}` : placeholder}
          </span>
          <div className="flex items-center gap-1">
            {selected && (
              <X className="w-4 h-4 text-muted-foreground hover:text-destructive"
                onClick={(e) => { e.stopPropagation(); onChange(""); }} />
            )}
            <ChevronsUpDown className="w-4 h-4 opacity-50" />
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Cerca socio…" value={query} onValueChange={setQuery} />
          <CommandList>
            <CommandEmpty>Nessun socio trovato.</CommandEmpty>
            <CommandGroup>
              {results.map((m) => (
                <CommandItem key={m.id} value={m.id} onSelect={() => { onChange(m.id); setOpen(false); }}>
                  <Check className={`mr-2 h-4 w-4 ${value === m.id ? "opacity-100" : "opacity-0"}`} />
                  <span className="truncate">{m.nome} {m.cognome}
                    {m.club && <span className="text-muted-foreground"> · {m.club}</span>}
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
